module.exports = __webpack_public_path__ + "img/Roberto_Raddi_profile.9bf8b4eb.png";